import React, { useContext } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { AuthState } from "../api/authApiClient";
import { AuthContext } from "../contexts/AuthProvider";

export const PublicRoute = () => {
  const { authState } = useContext(AuthContext);
  return authState === AuthState.AUTHORIZED ? <Navigate to="/" /> : <Outlet />;
};
